<template>
  <div class="heart-list-container">
    <h1 class="page-title">面部分析记录</h1>

    <!-- 添加刷新按钮，靠右对齐 -->
    <div class="refresh-container">
      <button @click="refreshPage" class="refresh-btn">点击刷新</button>
    </div>

    <div v-if="loading" class="loading">加载中...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <transition-group name="list" tag="ul" class="heart-list" v-else>
      <li v-for="item in sortedAndFilteredList" :key="item.Id" class="heart-item">
        <div class="item-content">
          <div class="item-info">
            <h3>{{ item.name }}</h3>
            <p>日期: {{ formatTime(item.time) }}</p>
          </div>
        </div>
        <div class="item-details">
          <div class="action-buttons">
            <button @click="viewFullAnalysis(item)" class="view-full-btn">查看完整分析</button>
            
          </div>
        </div>
      </li>
    </transition-group>

    <div v-if="recordList.length === 0 && !loading" class="no-results">
      没有找到匹配的记录
    </div>
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <p>等待获取结果，请不要关闭或退出页面</p>
    </div>
  </div>
</template>

<script>
import { postAction } from '@/api/manage';
import { ref } from 'vue';
export default {
  name: 'heartlistweibo',
  data() {
    return {
      recordList: [],
      loading: true,
      error: '',
      searchQuery: '',
      sortOption: 'time',
      isLoading: ref(false),
    };
  },
  computed:{
    weiboid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.$store.getters.getweiboid || '';
    },
    code(){
      return this.$route.query.code ? this.$route.query.code : ''
    },
    sortedAndFilteredList() {
      return this.recordList
        .filter(item => item.name.toLowerCase().includes(this.searchQuery.toLowerCase()))
        .sort((a, b) => {
          if (this.sortOption === 'time') {
            return new Date(b.time) - new Date(a.time);
          } else {
            return a.name.localeCompare(b.name);
          }
        });
    }
  },
  mounted(){
    if(!this.weiboid){
      if(!this.code){
        var url = encodeURIComponent(window.location.protocol+"//"+window.location.hostname+ '/heartlistweibo')
        window.location.href=`https://api.weibo.com/oauth2/authorize?client_id=3852406503&response_type=code&redirect_uri=`+ url
      } else {
         this.getJsLogin()
      }
    } else{
      this.fetchRecords()
    }
  },
  methods: {
    getJsLogin(){
        const url = '/wbfunc/wblogin'
        postAction(url, {code:this.code}).then( res => {
          this.userInfo = res.data.data
          this.$store.commit("setweiboid", this.userInfo.id);
          this.$store.commit("setweiboname", this.userInfo.name);
          this.$store.commit("setweiboimg", this.userInfo.cover_image_phone);
          this.$store.commit("setweibofoll", this.userInfo.followers_count);
          this.$store.commit("setweibodomin", this.userInfo.description);
              const url2 = '/wbfunc/wblogin/islg'
              postAction(url2, {code:this.userInfo.id}).then( res => {
                if(res.data.code == 200){
                  this.fetchRecords()
                } else {
                  this.$router.push({path:'/weibofaceRegister'})
                }
              })
        })
    },
    async fetchRecords() {
      const url = '/ai/face/facelist';
      this.loading = true;
      const res = await postAction(url, { unionid: this.weiboid })
      if (res.data.code == 200) {
        this.loading = false
        this.recordList = res.data.msg;
      } else {
        alert('返回数据格式错误')
        throw new Error('返回数据格式不符合预期');
      }

      // postAction(url, { unionid: this.weiboid })
      //   .then(response => {
      //     // 检查 response.data 是否存在并且包含预期的结构
      //     if (response.data && response.data.code === 200 && Array.isArray(response.data.msg)) {
      //       this.recordList = response.data.msg;
      //     } else {
      //       throw new Error('返回数据格式不符合预期');
      //     }
      //   })
      //   .catch(err => {
      //     this.recordList = [];
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    async gotoResult(item) {
      const url = '/ai/face/heartresult'
      try {
        this.isLoading = true
        const response = await postAction(url, {
          unionid: this.weiboid,
          filename: item.filename,
          pay: 1,
          name: item.name,
          tm: item.time
        });
        this.isLoading = false
        if (response.data && response.data.code === 200) {
          item.analysisData = response.data.msg;
          this.$set(item, 'showDetails', true);
        } else {
          throw new Error(response.data?.msg || '获取结果失败');
        }
      } catch (err) {
        alert(err.message || '获取结果失败，请稍后重试');
      }
    },
    toggleDetails(item) {
      if (!item.analysisData) {
        this.gotoResult(item);
      } else {
        this.$set(item, 'showDetails', !item.showDetails);
      }
    },
    viewFullAnalysis(item) {
      if (item.analysisData) {
        this.$router.push({
          name: 'heartresult',
          params: { analysisData: item.analysisData },
          query: { from: 'list' }  // 添加一个标记，表示来自列表页面
        });
      } else {
        // 如果还没有加载分析数据，先加载然后再跳转
        this.gotoResult(item).then(() => {
          this.$router.push({
            name: 'heartresult',
            params: { analysisData: item.analysisData },
            query: { from: 'list' }
          });
        });
      }
    },
    deleteReport(id) {
      if (confirm('确定要删除这条记录吗？')) {
        postAction('/ai/face/deletereport', { 'Id': id })
          .then(response => {
            if (response.data && response.data.code === 200) {
              // 删除成功，更新记录列表
              this.recordList = this.recordList.filter(item => item.Id !== id);
              // 显示成功消息
              alert(response.data.msg || '删除成功');
            } else {
              // 如果返回的 code 不是 200，也显示返回的消息
              throw new Error(response.data?.msg || '删除失败');
            }
          })
          .catch(err => {
            // 显示错误消息
            alert(err.message || '删除失败，请稍后重试');
          });
      }
    },
    formatTime(timeString) {
      return new Date(timeString).toLocaleString();
    },
    refreshPage() {
      this.$router.go(0); // 刷新页面
    }
  }
};
</script>

<style scoped>
.heart-list-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #fff0f5;
  min-height: 100vh;
}

.page-title {
  text-align: center;
  color: #ff69b4;
  margin-bottom: 30px;
}

.filter-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.search-input, .sort-select {
  padding: 10px;
  border: 1px solid #ffb6c1;
  border-radius: 5px;
  font-size: 16px;
}

.search-input {
  flex-grow: 1;
  margin-right: 10px;
}

.sort-select {
  width: 150px;
}

.heart-list {
  list-style-type: none;
  padding: 0;
}

.heart-item {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 15px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.heart-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
}

.item-content {
  display: flex;
  align-items: center;
  padding: 15px;
  cursor: pointer;
}

.item-info {
  flex-grow: 1;
}

.item-info h3 {
  margin: 0;
  color: #ff1493;
}

.expand-icon {
  transition: transform 0.3s ease;
}

.expand-icon.rotated {
  transform: rotate(180deg);
}

.item-details {
  padding: 0 15px 15px;
  background-color: #fff0f5;
}

.analysis-results p {
  margin: 5px 0;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.view-full-btn, .delete-btn {
  padding: 8px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.view-full-btn {
  background-color: #ff69b4;
  color: white;
}

.view-full-btn:hover {
  background-color: #ff1493;
}

.delete-btn {
  background-color: #ff9999;
  color: white;
}

.delete-btn:hover {
  background-color: #ff6666;
}

.loading, .error, .no-results {
  text-align: center;
  color: #ff69b4;
  font-style: italic;
  margin-top: 20px;
}

.list-enter-active, .list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9999;
  color: black; /* 修改字体颜色为黑色 */
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid #fff;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 添加样式 */
.refresh-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.refresh-btn {
  padding: 5px 10px;
  background-color: #ff69b4;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.refresh-btn:hover {
  background-color: #ff1493;
}
</style>
